<script>
    import Main from './layout/Main.svelte';
    import { t } from "../i18n";

    setTimeout(function(){
        location.href="https://www.fivedragons.ma/?p=contact";
    }, 1000);
</script>


<Main title={$t('page.contact')}>

    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">

            <div class="container-fluid">
                <div class="row">
                    <div class="col">

                        {$t('contact.redirecting')}

                    </div>
                </div>
            </div>
        </div>
    </div>

</Main>

